import {Brick, registerBrick} from 'olympe';

export default class GetSelectedFilterKeys extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} selectedFilters
     * @param {string} entity
     * @param {function()} forwardEvent
     * @param {function(!Array<string>)} setKeys
     * @param {function(*)} setNewSelectedFilters
     */
    update ($, [selectedFilters, entity], [forwardEvent, setKeys, setNewSelectedFilters]) {

        const filterKeys = Object.keys(selectedFilters);
        const finalKeys = [];
        filterKeys.forEach(key => {
            let newKey = key;
            // In gateway BCP21 table configuration, we are maintaining column name as workflowState and in BCP data model it is referred as bCPStatus. For this reason below mapping is required.
            if (key === 'bCPStatus') {
                newKey = 'workflowState';
            }
            const values = selectedFilters[key].values;
            if (!entity.includes(newKey) && Array.isArray(values) && values.length > 0) {
                finalKeys.push(newKey);
            }

        });
        let newSelectedFilters = {};
        finalKeys.forEach(key => {
            if (key === 'workflowState') {
                newSelectedFilters[key] = selectedFilters.bCPStatus;
            }
            else {
                newSelectedFilters[key] = selectedFilters[key];
            }
        });

        setKeys(finalKeys);
        setNewSelectedFilters(newSelectedFilters);
        forwardEvent();
    }
}

registerBrick('018d63b4f48f1989f307', GetSelectedFilterKeys);
